import { GamingReportsHeader } from './GamingReportsHeader'

export const GamingReportsPage = () => {
  return (
    <GamingReportsHeader
      currentTab={'/GamingReports/CreditsWageredByMachinePage'}
    ></GamingReportsHeader>
  )
}
